import { render, staticRenderFns } from "./RaCustomPeriod.vue?vue&type=template&id=137835c6"
import script from "./RaCustomPeriod.vue?vue&type=script&lang=js"
export * from "./RaCustomPeriod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports